import { unstable_isUnrecognizedActionError } from "next/navigation";

/**
 * Fired on `window` just before the page reloads onto a new build: open prompt boxes keep their
 * words for the reloaded page then.
 */
export const RELOADING_EVENT = "firm:reloading-for-new-build";

const RELOADED_AT = "firm:reloaded-for-new-build";
/** A page still on an old build this soon after reloading for it is not reloaded again. */
const AGAIN_MS = 30_000;

/**
 * A server action called from a page an older or newer build served fails as unrecognized: the
 * page reloads so its next action reaches the build that is running. Returns whether it reloads;
 * a page that reloaded for this a moment ago is left alone, so a mismatch never loops.
 */
export function reloadIfNewBuild(error: unknown): boolean {
  if (!unstable_isUnrecognizedActionError(error)) return false;
  try {
    const last = Number(window.sessionStorage.getItem(RELOADED_AT) ?? 0);
    if (Date.now() - last < AGAIN_MS) return false;
    window.sessionStorage.setItem(RELOADED_AT, String(Date.now()));
  } catch {
    // Storage off: no way to tell a loop from a first reload, so stay on the page.
    return false;
  }
  window.dispatchEvent(new Event(RELOADING_EVENT));
  window.location.reload();
  return true;
}
